import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import DataCollectTable from "@com/table/DataCollectTable.vue";
import { OP_KEY, OPERATIONS, operationsHander } from "@com/table/tableOperations";
import { ref, reactive } from "vue";
import { Search } from "@element-plus/icons-vue";
import api from "@api/coupon";
import useRoute from "@util/router";
import BackTitleView from "@/components/BackTitleView.vue";
import { $box, $msg } from "@/common/ui/msg";
export default {
  __name: 'CouponGrantRecord',

  setup(__props) {
    const route = useRoute();
    const title = ref("发放记录");
    const size = ref(20);
    const page = ref(1);
    const total = ref(0);
    const data = ref([]);
    getData();

    function getData() {
      let routeQuery = route.query();
      let params = {
        couponCode: routeQuery.code,
        page: page.value,
        size: size.value
      };
      api.couponSendList(params, val => {
        total.value = val.total;
        data.value = val.list;
      });
    }

    function getOperations(data) {
      let op = [];

      if (data.num <= 0) {
        op.push(OPERATIONS.del);
      }

      if (data.status == '未使用') {
        op.push(OPERATIONS.revoke, OPERATIONS.userStop);
      }

      return op;
    }

    const config = {
      showIndex: true,
      operations: {
        label: "操作",
        width: 120,
        operations: getOperations
      },
      column: [{
        label: "所属用户",
        prop: "user",
        width: 200
      }, {
        label: "状态",
        prop: "status",
        width: 100
      }, {
        label: "发放方式",
        prop: "sendType"
      }, {
        label: "发放时间",
        prop: "sendTime"
      }, {
        label: "关联订单",
        prop: "order"
      }, {
        label: "停用原因",
        prop: "stopReason"
      }]
    };
    const opHander = operationsHander();
    opHander.install(OP_KEY.userStop, data => {
      $box.input("停用", "停用原因", data.stopReason, val => {
        let params = {
          couponItemCode: data.couponItemCode,
          useFlag: 2,
          stopReason: val
        };
        api.memberCouponUpdateWay(params, () => {
          getData();
          $msg.succ("停用优惠券成功");
        });
      });
    });
    opHander.install(OP_KEY.revoke, data => {
      $box.input("撤回", "撤回原因", data.stopReason, val => {
        let params = {
          couponItemCode: data.couponItemCode,
          useFlag: -1,
          stopReason: val
        };
        api.memberCouponUpdateWay(params, () => {
          getData();
          $msg.succ("撤回优惠券成功");
        });
      });
    });

    function dataPageChange(type, val) {
      if (type == 'page') {
        page.value = val;
      } else if (type == 'size') {
        size.value = val;
      }

      getData();
    }

    return (_ctx, _cache) => {
      const _component_el_main = _resolveComponent("el-main");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: title.value
        }, null, 8, ["title"]), _createVNode(_component_el_main, {
          class: "base_main_content",
          style: {
            "max-height": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(DataCollectTable, {
            data: data.value,
            total: total.value,
            config: config,
            isRoute: false,
            onOperationsHander: _unref(opHander).receive,
            onPageChange: dataPageChange
          }, null, 8, ["data", "total", "onOperationsHander"])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = $event => _unref(route).go(-1))
          }, {
            default: _withCtx(() => [_createTextVNode("返回")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};